/**
 * Removes element from index `index` and returns the resulting new array.
 * @param array
 * @param index
 */
export const removeAt = (array: unknown[], index: number): unknown[] => {
  const newArray = [...array];
  newArray.splice(index, 1);
  return newArray;
};

/**
 * Checks if a given element belongs to a collection of elements.
 *
 * This is the same functionality as `Array.includes` but fixes its TS problem
 * with narrow types:
 * https://fettblog.eu/typescript-array-includes/#option-2%3A-a-helper-with-type-assertions
 *
 */
export const narrowIncludes = <TArrayItem extends TElement, TElement>(
  array: ReadonlyArray<TArrayItem>,
  element: TElement,
): element is TArrayItem => array.includes(element as TArrayItem);
